module.exports = __webpack_public_path__ + "img/ico-notification-bell.1995fa07.svg";